import React from 'react';
import { Box } from '@mui/material';
import PaymentCancelledPopup from '../components/Payment/PaymentCancelledPopup';

const PaymentCancelledPage: React.FC = () => {
  // Notify parent window if opened in popup
  React.useEffect(() => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: 'PAYMENT_CANCELLED' },
        window.location.origin
      );
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 2,
      }}
    >
      <PaymentCancelledPopup open={true} />
    </Box>
  );
};

export default PaymentCancelledPage;

